var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('img',{attrs:{"src":require("@/static/error/404.png"),"alt":"404Error"}}),_vm._v(" "),_c('nuxt-link',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.$t('button.back_home')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }